'use client'
import React from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import reactHtmlParser from "react-html-parser";
import {Img} from "@/components/Img";
import {Black, title} from '@/styles/globalStyleVars'
import SectionBg from "@/public/images/static/benefit-bg.png";
import Title from "@/components/Title";
import ThemeRow from "@/components/theme/row";

const ServiceOverview = ({data}) => {
    return (
        <StyledOverview className='service-overview pt-200 pb-200'>
            {
                data?.img &&
                <Img objectFit={'cover'} alt={data?.title} src={data?.img}/>

            }
            <ThemeRow>
                <Col sm={7}>
                    <Title text={data?.title} number={'I'} background={"#8C263D"}/>
                </Col>
                <Col sm={8}>
                    {
                        reactHtmlParser(data?.description)
                    }
                </Col>
            </ThemeRow>
        </StyledOverview>
    );
};

const StyledOverview = styled.section`
    overflow: hidden;
    position: relative;

    img {
        object-fit: cover !important;
    }

    .title {
        p{
            display: none;
        }
        &:after{
            bottom: -67px;
        }
    }
    
    ul{
        display: flex;
        flex-direction: column;
        padding-left: 88px;
        margin-top: 80px;
        gap: 40px;
        li{
            position: relative;
            color: ${Black};
            font-size: 20px;
            line-height: 28px;
            font-weight: 500;
            counter-increment: count;
            padding-left: 20px;
            
            &:before {
                content: counter(count, upper-alpha);
                position: absolute;
                height: 18px;
                width: 18px;
                padding: 0;
                background: ${Black};
                border-radius: 50%;
                color: white;
                top: 10px;
                left: -20px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 12px;
                font-weight: 500;
                line-height: 18px;
            }
        }
    }
    
    
    @media(max-width: 767px){
        .list{
            padding-left: 0;
            li{
                padding-left: 30px;
                &:before{
                    left: 0;
                }
            }
        }
        
        .title{
            p{
                display: block;
            }
        }
        
        h2{
            padding-left: 0 !important;
        }
        
    }
`;

export default ServiceOverview;
